module.exports = __webpack_public_path__ + "static/media/ge.782bbcba.svg";